import React from 'react';
import axios from 'axios';
import App from "./App";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css'
import 'bootstrap';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from './components/Accounts/Auth/authconfig';
import "react-loading-skeleton/dist/skeleton.css";
import "react-datepicker/dist/react-datepicker.css";
import Context from "./Context/Context";

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      const fullPath = window.location.pathname + window.location.search;
      if (fullPath.startsWith('/') && fullPath !== '/' && !fullPath.startsWith('/error/')) {
        sessionStorage.setItem('redirectAfterLogin', fullPath);
      }
    }
    return Promise.reject(error);
  }
);

export const pca = new PublicClientApplication(msalConfig);
pca.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS) {
    pca.setActiveAccount(event.payload.account);
  }
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <Context>
    <Router>
      <App msalInstance={pca} />
    </Router>
  </Context>
  //  </React.StrictMode>
);
